import { useState, useCallback } from "react";

// libraries
import { PinInput } from "react-input-pin-code";

// material ui components
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

// providers and context
import { AuthConfig } from "../../../setup/context/config/authConfig";

// constants
import { SECURITY_CODE, BUTTON } from "./constant";

// styles
import securityPinStyles from "./styles.module.css";
import Button from "../../common/button";

// apis
import { verifyPinCode, updatePinCode } from "../../../setup/api/services/user";

const PaymentPin = (): JSX.Element => {
  const userId = AuthConfig.getUserInfo()?.id;
  const [values, setValues] = useState(["", "", "", "", "", ""]);
  const [currentPincode, setCurrentPincode] = useState("");
  const [updatedPincode, setUpdatedPincode] = useState("");

  const [pinVerified, setPinVerified] = useState(false);
  const [pinUpdated, setPinUpdated] = useState(false);

  const inputStyles = {
    background: "#FFFFFF",
    border: `1px solid #5BBDFF`,
    borderRadius: `8px`,

    fontFamily: "Rubik",
    fontWeight: 700,
    fontSize: "32px",
    color: "#000000",
  };

  const handlePinVerified = async (pincode: string) => {
    setCurrentPincode(pincode);
    try {
      const body = { pinCode: pincode };
      const result = await verifyPinCode(userId, body);
      if (result?.data?.valid) {
        setPinVerified(true);
        setValues(["", "", "", "", "", ""]);
      } else {
        setPinVerified(false);
        setValues(["", "", "", "", "", ""]);
      }
    } catch (error) {
      console.error(error);
      setPinVerified(false);
      setValues(["", "", "", "", "", ""]);
    }
  };

  const handlePinUpdate = async (pincode: string) => {
    setUpdatedPincode(pincode);
    try {
      const body = {
        oldPinCodeOrPassword: currentPincode,
        newPinCode: pincode,
        reNewPinCode: pincode,
      };
      const result = await updatePinCode(userId, body);
      if (result?.data?.valid) {
        setPinUpdated(true);
      } else {
        setPinUpdated(false);
      }
    } catch (error) {
      console.error(error);
      setPinUpdated(false);
    }
  };

  const onVerify = () => {
    handlePinVerified(values.join(""));
  };

  const onEditCode = () => {
    handlePinUpdate(values.join(""));
  };

  return (
    <Box dir="rtl" className={securityPinStyles.paymentMethodsContainer}>
      <>
        {pinUpdated ? (
          <div>
            <Box component="img" src="/assets/images/svg/tick.svg" />
            <Typography className={securityPinStyles.noPaymentMethodsTitle}>
              {SECURITY_CODE.SUCCESSFULLY_SET}
            </Typography>
          </div>
        ) : (
          <div>
            <Typography className={securityPinStyles.noPaymentMethodsTitle}>
              {!pinVerified
                ? SECURITY_CODE.SECURITY_CODE
                : SECURITY_CODE.CHANGE_SECURITY_CODE}
            </Typography>
            <Typography className={securityPinStyles.noPaymentMethodsSubTitle}>
              {!pinVerified
                ? SECURITY_CODE.ENTER_SECURITY_CODE
                : SECURITY_CODE.ENTER_CURRENT_SECURITY_CODE}
            </Typography>
            <div dir="ltr" className={securityPinStyles["container"]}>
              <PinInput
                name={"securityCode"}
                type="number"
                mask={true}
                values={values}
                onChange={(value, index, values) => {
                  setValues(values);
                }}
                inputStyle={inputStyles}
              />
            </div>
            {!pinVerified ? (
              <Button onClick={onVerify}>{BUTTON.EMPHASIS}</Button>
            ) : (
              <Button onClick={onEditCode}>{BUTTON.TRACKING}</Button>
            )}
          </div>
        )}
      </>
    </Box>
  );
};

export default PaymentPin;
